import { type RouteRecordRaw } from 'vue-router'
import './route-types'

export function createStakeholderRoutes(startPath: string) {
  return [
    {
      path: startPath,
      component: () => import('./components/layouts/StakeholderLayoutRoot.vue'),
      props: true,
      redirect: () => ({
        name: 'stakeholders.overview'
      }),
      children: [
        {
          path: 'overview',
          component: () =>
            import('./components/layouts/StakeholderLayoutSearch.vue'),
          props: true,
          children: [
            {
              path: '',
              name: 'stakeholders.overview',
              component: () => import('./views/StakeholdersViewOverview.vue'),
              props: true
            }
          ]
        }
      ]
    }
  ] as readonly RouteRecordRaw[]
}
